import { render } from "./ClomosDevices.vue?vue&type=template&id=194d5453"
import script from "./ClomosDevices.vue?vue&type=script&lang=js"
export * from "./ClomosDevices.vue?vue&type=script&lang=js"

import "./ClomosDevices.vue?vue&type=style&index=0&id=194d5453&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__